import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from './ThemeToggle';
import { useAuth } from '../contexts/AuthContext';
import { landingPath } from '../utils/permissionUtils';
import UserMenu from './UserMenu';

// Where to go next is shown as icons, the same ones (and the same hover) as the top right of the app: Home, the
// Marketplace and Contact. Signing in and creating an account stay as words, since a new visitor has to find them.
const ICON_LINKS = [
  { to: '/', label: 'Home', icon: 'bi-house', cls: 'home' },
  { to: '/shop', label: 'Marketplace', icon: 'bi-shop', cls: 'shop' },
  { to: '/contact', label: 'Contact us', icon: 'bi-envelope', cls: 'contact' },
];
const SIGNED_OUT_LINKS = [
  { to: '/login', label: 'Sign In' },
  { to: '/register', label: 'Create Account' }
];

// Same header band pattern as the logged-in Layout.js Navbar (border-bottom, body-tertiary,
// data-bs-theme), so public and authenticated pages read as one product instead of two.
function PublicHeader() {
  const { pathname } = useLocation();
  const { theme } = useTheme();
  const { user } = useAuth();
  // Someone already signed in sees their own menu, and Home takes them into the app, not sign-in and sign-up
  const icons = user ? ICON_LINKS.map((l) => (l.to === '/' ? { ...l, to: landingPath(user) } : l)) : ICON_LINKS;

  return (
    <Navbar expand="md" className="border-bottom" data-bs-theme={theme} bg="body-tertiary">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src="https://s3.amazonaws.com/public.ibigdo.com/c/img/logo_ibigdo.png"
            alt="iBigDo"
            style={{ height: '34px', objectFit: 'contain' }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="public-nav" />
        <Navbar.Collapse id="public-nav">
          <Nav className="ms-auto align-items-md-center">
            {icons.map((link) => (
              <Nav.Link
                key={link.cls}
                as={Link}
                to={link.to}
                active={pathname === link.to || (link.to === '/shop' && pathname.startsWith('/shop'))}
                title={link.label}
                aria-label={link.label}
                className={`topnav-icon topnav-icon-${link.cls}`}
              >
                <i className={`bi ${link.icon}`} aria-hidden="true" />
                <span className="d-md-none ms-2">{link.label}</span>
              </Nav.Link>
            ))}
            {!user && SIGNED_OUT_LINKS.map((link) => (
              <Nav.Link key={link.to} as={Link} to={link.to} active={pathname === link.to}>{link.label}</Nav.Link>
            ))}
            <ThemeToggle />
            {user && <UserMenu />}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default PublicHeader;
